'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import Lockup from 'components/blocks/shared/Lockup';
import Img from 'components/ui/Img';

import { blockRootProps } from 'utils';

import styles from './BlockTwoColumnGrid.module.scss';

const BlockTwoColumnGrid = ({
    __typename,
    icon,
    eyebrow,
    headline,
    body,
    cta,
    image,
    imagePosition,
    flushTop,
    flushBottom,
}) => {
    imagePosition ??= 'Left';

    return (
        <div
            {...blockRootProps(undefined, __typename)}
            className={cx(styles.root, {
                [styles.flushTop]: flushTop,
                [styles.flushBottom]: flushBottom,
                [styles.imageRight]: imagePosition.toLowerCase() === 'Right',
            })}
        >
            {image?.url && (
                <Img
                    className={styles.image}
                    src={image.url}
                    width={image?.width}
                    height={image?.height}
                    alt={image?.description || ''}
                    fallbackImageWidth={768}
                />
            )}
            <div className={styles.card}>
                <div className={styles.cardInner}>
                    <Lockup
                        icon={icon}
                        eyebrow={{ text: eyebrow }}
                        headline={{
                            text: headline,
                            themeOverrides: {
                                baseTheme: 'headingMedium',
                                themes: {
                                    large: 'headingLarge',
                                },
                            },
                        }}
                        copy={{ text: body }}
                        ctas={cta}
                        theme="Small"
                    />
                </div>
            </div>
        </div>
    );
};

BlockTwoColumnGrid.propTypes = {
    __typename: PropTypes.string,
    body: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
    cta: PropTypes.object,
    eyebrow: PropTypes.string,
    flushBottom: PropTypes.bool,
    flushTop: PropTypes.bool,
    headline: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
        .isRequired,
    image: PropTypes.shape({
        url: PropTypes.string,
    }),
    imagePosition: PropTypes.oneOf(['Left', 'Right']),
};

export default BlockTwoColumnGrid;
